import { useEffect, useMemo, useState } from "react";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3 } from "../utils/zz/zz-yourmap-utils";
import { _zzyourmap_routing_browser_title_update } from "../utils/zz/zz-yourmap-routing";
import YourmapCardTeaser from "./YourmapCardTeaser";

const ITEMS_PER_PAGE = 9;
const FILTER_ALL_KEY = "__all__";

export const YourmapSectionYmthingList = (props) => {
  const {
    current_destination_entity,
    route_destination_id,
    route_destination_tab,
    ymthing_entities,
  } = props.appPack;

  let _naslov_za_list = "";
  let is_tab_default = false;
  if (route_destination_tab === null) {
    is_tab_default = true;
  }

  if (is_tab_default || route_destination_tab === "smestaji") {
    _naslov_za_list = "Selekcija smeštaja";
  } else if (route_destination_tab === "restorani") {
    _naslov_za_list = "Selekcija restorana";
  } else if (route_destination_tab === "servisi") {
    _naslov_za_list = "Selekcija servisa";
  } else if (route_destination_tab === "prodavnice") {
    _naslov_za_list = "Selekcija prodavnica";
  } else if (route_destination_tab === "aktivnosti") {
    _naslov_za_list = "Selekcija aktivnosti";
  } else if (route_destination_tab === "znamenitosti") {
    _naslov_za_list = "Selekcija znamenitosti";
  } else if (route_destination_tab === "ostalo") {
    _naslov_za_list = "Ostalo";
  } else if (route_destination_tab === "blog") {
    _naslov_za_list = "Blog";
  }

  if (Easy69_v1.is_string_not_empty(current_destination_entity?.destinacija_naslov_sufix_za_liste)) {
    _naslov_za_list += " " + current_destination_entity.destinacija_naslov_sufix_za_liste;
  }

  _zzyourmap_routing_browser_title_update(_naslov_za_list);

  const ymthing_entities_of_destination = _zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3(
    ymthing_entities,
    route_destination_id,
    route_destination_tab
  );

  const [filtersSubdestinations, setFiltersSubdestinations] = useState({});
  const [entitySearchQuery, setEntitySearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const unfilteredEntities = useMemo(() => {
    const arr = Array.isArray(ymthing_entities_of_destination) ? [...ymthing_entities_of_destination] : [];
    return arr.sort((a, b) => {
      const orderA = Number(a?.smestaj_order_index);
      const orderB = Number(b?.smestaj_order_index);
      const safeA = Number.isFinite(orderA) ? orderA : Number.MAX_SAFE_INTEGER;
      const safeB = Number.isFinite(orderB) ? orderB : Number.MAX_SAFE_INTEGER;
      if (safeA !== safeB) {
        return safeA - safeB;
      }
      return Number(a?.of_id || 0) - Number(b?.of_id || 0);
    });
  }, [ymthing_entities_of_destination]);

  useEffect(() => {
    setFiltersSubdestinations(() => {
      if (current_destination_entity?.of_id > 0 && Array.isArray(current_destination_entity?._subdestinations)) {
        const updatedState = { [FILTER_ALL_KEY]: true };
        current_destination_entity._subdestinations.forEach((subdestinationItem) => {
          updatedState[subdestinationItem._option_value_regular] = false;
        });
        return updatedState;
      }
      return { [FILTER_ALL_KEY]: true };
    });
    setCurrentPage(1);
  }, [current_destination_entity?.of_id]);

  useEffect(() => {
    setCurrentPage(1);
  }, [entitySearchQuery]);

  const normalizedSearchQuery = (entitySearchQuery || "").trim().toLowerCase();

  const filteredEntitiesOfDestination = unfilteredEntities.filter((item) => {
    const isAllFilterActive = filtersSubdestinations?.[FILTER_ALL_KEY] === true;
    if (!isAllFilterActive && !(item.parent_destinacija_id > 0 && filtersSubdestinations?.[item.parent_destinacija_id] === true)) {
      return false;
    }

    if (!normalizedSearchQuery) {
      return true;
    }

    const searchableValues = [
      item?.smestaj_naslov,
      item?.smestaj_podnaslov,
      item?.smestaj_adresa,
      item?.smestaj_lokacija,
    ].filter((value) => Easy69_v1.is_string_not_empty(value));

    const searchableText = searchableValues.join(" ").toLowerCase();
    return searchableText.includes(normalizedSearchQuery);
  });

  const totalItems = filteredEntitiesOfDestination.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / ITEMS_PER_PAGE));
  const pageStart = (currentPage - 1) * ITEMS_PER_PAGE;
  const pageEnd = pageStart + ITEMS_PER_PAGE;
  const pagedEntities = filteredEntitiesOfDestination.slice(pageStart, pageEnd);

  const hasActiveFilters =
    filtersSubdestinations?.[FILTER_ALL_KEY] !== true;

  const handleFilterAll = () => {
    if (!Array.isArray(current_destination_entity?._subdestinations)) return;

    const nextState = { [FILTER_ALL_KEY]: true };
    current_destination_entity._subdestinations.forEach((sub) => {
      nextState[sub._option_value_regular] = false;
    });

    setFiltersSubdestinations(nextState);
    setCurrentPage(1);
  };

  const handleFilterChipToggle = (optionValue) => {
    setFiltersSubdestinations((state) => {
      const nextState = {
        ...state,
        [FILTER_ALL_KEY]: false,
        [optionValue]: state?.[optionValue] !== true,
      };

      const hasAnyLocationActive = Array.isArray(current_destination_entity?._subdestinations)
        && current_destination_entity._subdestinations.some((sub) => nextState?.[sub._option_value_regular] === true);

      if (!hasAnyLocationActive) {
        nextState[FILTER_ALL_KEY] = true;
      }

      return nextState;
    });
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    handleFilterAll();
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const delta = 2;
    const left = Math.max(1, currentPage - delta);
    const right = Math.min(totalPages, currentPage + delta);

    if (left > 1) {
      pages.push(1);
      if (left > 2) pages.push("...");
    }

    for (let i = left; i <= right; i++) pages.push(i);

    if (right < totalPages) {
      if (right < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  const showingFrom = totalItems === 0 ? 0 : pageStart + 1;
  const showingTo = Math.min(pageEnd, totalItems);

  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__listing-header">
            <div className="uu-gap-standalone-1rem"></div>
            <h2 className="yourmap__listing-title">{_naslov_za_list}</h2>
            <p className="yourmap__listing-subtitle">Istraži savete, preporuke i esencijalne informacija za tvoje putovanje</p>

            {Array.isArray(current_destination_entity?._subdestinations) && current_destination_entity._subdestinations.length > 0 && (
              <div className="yourmap__filter-section">
                <div className="yourmap__filter-section__label">Filter po lokaciji</div>
                <div className="yourmap__filter-chips">
                  <button
                    type="button"
                    className={"yourmap__filter-chip" + (filtersSubdestinations?.[FILTER_ALL_KEY] === true ? " yourmap__filter-chip--active" : "")}
                    onClick={handleFilterAll}
                  >
                    Sve
                  </button>

                  {current_destination_entity._subdestinations.map((item) => {
                    const isActive = filtersSubdestinations?.[item._option_value_regular] === true;
                    return (
                      <button
                        key={item._option_value_regular}
                        type="button"
                        className={"yourmap__filter-chip" + (isActive ? " yourmap__filter-chip--active" : "")}
                        onClick={() => handleFilterChipToggle(item._option_value_regular)}
                      >
                        {item._option_title}
                      </button>
                    );
                  })}

                  {hasActiveFilters && (
                    <button
                      type="button"
                      className="yourmap__filter-chip-clear"
                      onClick={handleClearFilters}
                    >
                      Poništi filtere
                    </button>
                  )}

                  <div className="yourmap__filter-search-wrap">
                    <input
                      type="search"
                      className="yourmap__filter-search-input"
                      placeholder="Pretraži entitete..."
                      value={entitySearchQuery}
                      onChange={(e) => setEntitySearchQuery(e.target.value)}
                      aria-label="Pretraga entiteta"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {totalItems === 0 ? (
            <div className="yourmap__listing-empty">
              <span className="yourmap__listing-empty__icon">🔍</span>
              <p>Nema rezultata koji odgovaraju odabranim filterima.</p>
              {hasActiveFilters && (
                <button type="button" className="yourmap__filter-chip-clear" onClick={handleClearFilters}>
                  Poništi filtere
                </button>
              )}
            </div>
          ) : (
            <>
              <div className="yourmap__grid yourmap__grid--gaps-1rem yourmap__grid--items-w-1-3">
                {pagedEntities.map((item, index) => (
                  <div key={index} className="xi">
                    <YourmapCardTeaser appPack={props.appPack} item={item} />
                  </div>
                ))}
              </div>

              <div className="yourmap__pagination-area">
                <div className="yourmap__pagination-summary">
                  Prikazano {showingFrom}–{showingTo} od {totalItems} rezultata
                </div>
                {totalPages > 1 && (
                  <div className="yourmap__pagination">
                    <button
                      type="button"
                      className="yourmap__pagination__btn yourmap__pagination__btn--prev"
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                      aria-label="Prethodna stranica"
                    >
                      ‹
                    </button>
                    {getPageNumbers().map((page, idx) =>
                      page === "..." ? (
                        <span key={"ellipsis-" + idx} className="yourmap__pagination__ellipsis">…</span>
                      ) : (
                        <button
                          key={page}
                          type="button"
                          className={
                            "yourmap__pagination__btn yourmap__pagination__page-btn" +
                            (page === currentPage ? " yourmap__pagination__btn--active" : "")
                          }
                          onClick={() => handlePageChange(page)}
                          aria-current={page === currentPage ? "page" : undefined}
                        >
                          {page}
                        </button>
                      )
                    )}
                    <button
                      type="button"
                      className="yourmap__pagination__btn yourmap__pagination__btn--next"
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                      aria-label="Sledeća stranica"
                    >
                      ›
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default YourmapSectionYmthingList;
